<template lang="pug">
app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="closeModal()"
)
  template(slot="body")
    div.upload
      app-documentos(
        :maxSize='20',
        :valid-extensions="extensoes",
        :documentos="documentos"
        :tiposDocumentos="tiposDocumentos",
        :tiposDocumentosObrigatorios="tiposDocumentos",
        :observer="this.$refs.validation",
        :isDocumentoImagex="true"
        titulo="Documentos do Interessado",
        aba="Interessado",
      )
    div.texto
      app-resposta(
        :showAnexos="false"
        @anexar="anexar"
        @close="close"
      )

</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import AppResposta from './AppResposta'

export default {

  components: {
    AppModal,
    AppDocumentos,
    AppResposta
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    width: {
      type: Number,
      default: 900
    },
    titulo: {
      type: String,
      required: true
    },
    protocolo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      tiposDocumentos: [],
      extensoes: ['pdf', 'jpeg', 'png', 'jpg'],
      documentos: []
    }
  },

  async created () {
    this.tiposDocumentos = await this.findTiposDocumentoInvalidos({
      protocolo: this.protocolo
    })
    this.$store.commit('conversas/SET_TIPO_ANEXOS_PENDENTES_CONVERSA', this.tiposDocumentos)
  },

  methods: {
    ...mapActions({
      findTiposDocumentoInvalidos:
        'tipoDocumento/findTiposDocumentoInvalidos'
    }),

    closeModal () {
      this.$emit('closeModal')
    },
    anexar () {
      this.$store.commit('conversas/SET_RESPOSTA_ANEXO', this.documentos.map(b => ({
        nome: b.fileName,
        key: b.fileKey,
        tipo: b.tipoDocumento
      })))
    },
    close () {
      this.closeModal()
      this.$router.push({
        name: 'caixa-entrada'
      })
    }

  }
}

</script>

  <style scoped lang="scss">

  .texto {
    font-size: 17px;
  }
  .upload {
    margin-top: -30px;
  }
  .texto {
    margin-top: -40px;
  }

  </style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppModalInserirDocumentos.vue